import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { TrendingUp, MessageSquare, Bell, IndianRupee, Newspaper, Users } from "lucide-react";

export default function AnalyticsPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-slate-500">लोड हो रहा है…</div>;
  return (
    <div data-testid="admin-analytics-page">
      <h1 className="font-devnagri-heading text-3xl font-black text-[#0F172A] mb-2">Analytics · विश्लेषिकी</h1>
      <p className="text-sm text-slate-500 mb-6">आपके पोर्टल का प्रदर्शन एक नज़र में</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
        <Stat icon={Newspaper} label="कुल लेख" value={data.news.total} sub={`${data.news.published} प्रकाशित`}/>
        <Stat icon={TrendingUp} label="कुल दृश्य" value={data.news.total_views.toLocaleString("hi-IN")} sub="Top 10"/>
        <Stat icon={MessageSquare} label="टिप्पणियाँ" value={data.comments.total} sub={`${data.comments.approved} अनुमोदित`}/>
        <Stat icon={Bell} label="पुश सब्सक्राइबर" value={data.push_subs} sub="सक्रिय"/>
        <Stat icon={Users} label="Premium Subscribers" value={data.subscribers} sub="Ad-Free"/>
        <Stat icon={IndianRupee} label="कुल दान" value={`₹${data.payments.donation.total.toLocaleString("hi-IN")}`} sub={`${data.payments.donation.count} डोनर्स`}/>
        <Stat icon={IndianRupee} label="विज्ञापन राजस्व" value={`₹${data.payments.classified.total.toLocaleString("hi-IN")}`} sub={`${data.payments.classified.count} ads`}/>
        <Stat icon={IndianRupee} label="Sub राजस्व" value={`₹${(data.payments.subscription?.total || 0).toLocaleString("hi-IN")}`} sub={`${data.payments.subscription?.count || 0} sub`}/>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-lg p-5">
          <h3 className="font-bold text-[#0F172A] mb-4 flex items-center gap-2"><TrendingUp className="w-4 h-4 text-[#DC2626]"/>Top 10 समाचार</h3>
          <ol className="space-y-2">
            {data.top_news.map((n, i) => (
              <li key={n.slug} className="flex items-center gap-3 pb-2 border-b border-slate-100 last:border-0" data-testid={`top-${i}`}>
                <div className="w-6 h-6 rounded-full bg-[#0F172A] text-white text-xs flex items-center justify-center font-bold shrink-0">{i + 1}</div>
                <Link to={`/article/${n.slug}`} className="flex-1 min-w-0 text-sm hover:text-[#DC2626]">
                  <div className="font-medium text-[#0F172A] line-clamp-1">{n.title}</div>
                  <div className="text-[10px] uppercase tracking-widest text-slate-400">{n.category}</div>
                </Link>
                <div className="text-emerald-700 font-bold text-sm shrink-0">{n.views.toLocaleString("hi-IN")} <span className="text-[9px] text-slate-400">views</span></div>
              </li>
            ))}
          </ol>
        </div>

        <div className="bg-white border border-slate-200 rounded-lg p-5">
          <h3 className="font-bold text-[#0F172A] mb-4">श्रेणी-वार प्रदर्शन</h3>
          <div className="space-y-3">
            {data.categories.sort((a, b) => b.views - a.views).slice(0, 10).map((c) => {
              const max = Math.max(...data.categories.map((x) => x.views), 1);
              return (
                <div key={c.name}>
                  <div className="flex items-baseline justify-between text-xs mb-1">
                    <div className="font-medium text-[#0F172A]">{c.name}</div>
                    <div className="text-slate-500">{c.articles} लेख · <b className="text-[#0F172A]">{c.views.toLocaleString("hi-IN")}</b> views</div>
                  </div>
                  <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-[#EA580C] to-amber-400" style={{ width: `${(c.views / max * 100).toFixed(0)}%` }}/>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value, sub }) {
  return (
    <div className="bg-white rounded-lg border border-slate-200 p-4">
      <div className="flex items-center gap-2 mb-2"><Icon className="w-4 h-4 text-[#EA580C]"/><div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">{label}</div></div>
      <div className="text-2xl font-black text-[#0F172A]">{value}</div>
      <div className="text-[10px] text-slate-400 mt-0.5">{sub}</div>
    </div>
  );
}
